// src/store/pipeline.js

// -- Action Type Constants --
const SET_PIPELINE = "SET_PIPELINE";
const SET_PIPELINE_KEY = "SET_PIPELINE_KEY";
const CLEAR_PIPELINE = "CLEAR_PIPELINE";

// -- Initial State --
const initialState = {
  // applicationDeals: null,
  // creditAuthorizations: null,
  // closedLoans: null,
};

// -- Reducer --
export default function pipelineReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PIPELINE:
      // replace entire state
      return action.payload;

    case SET_PIPELINE_KEY: {
      const { key, value } = action.payload;
      // if nothing changed, return old state
      if (state[key] === value) {
        return state;
      }
      // shallow‐copy + override one key
      return {
        ...state,
        [key]: value,
      };
    }

    case CLEAR_PIPELINE:
      // reset to initial (same object reference every time)
      return initialState;

    default:
      return state;
  }
}

// — action creators —
// implicit return, minimal object creation

export const pipelineSet = (payload) => ({
  type: SET_PIPELINE,
  payload,
});

export const pipelineSetKey = (key, value) => ({
  type: SET_PIPELINE_KEY,
  payload: { key, value },
});

// set individual fields
export const pipelineSetApplicationDeals = (applicationDeals) => ({
  type: SET_PIPELINE_KEY,
  payload: { key: "applicationDeals", value: applicationDeals },
});

export const pipelineSetCreditAuthorizations = (creditAuthorizations) => ({
  type: SET_PIPELINE_KEY,
  payload: { key: "creditAuthorizations", value: creditAuthorizations },
});

export const pipelineSetClosedLoans = (closedLoans) => ({
  type: SET_PIPELINE_KEY,
  payload: { key: "closedLoans", value: closedLoans },
});

// reset pipeline to initial
export const pipelineClear = () => ({
  type: CLEAR_PIPELINE,
});
